<template>
  <div class="report-borrowed">
    <NavBar class="nav--bar" />
    <AuthBySessionExpired class="auth--by--session--expired" />
    <div class="container">
      <b-modal
        id="filter"
        size="md"
        no-close-on-backdrop
        hide-footer
        title="FILTRAR"
      >
        <div class="row">
          <div
            v-if="false"
            class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0"
          >
            <h6>SELECIONAR TODOS OS RESIDENTES?</h6>
            <b-form-group>
              <b-form-radio v-model="select_all_residents" :value="false"
                >NÃO</b-form-radio
              >
              <b-form-radio v-model="select_all_residents" :value="true"
                >SIM</b-form-radio
              >
            </b-form-group>
          </div>
          <div
            v-show="!select_all_residents"
            class="col-xl-12 col-sm-12 col-md-12 col-sm-12 col-12 pt-0 pb-0 text-center"
          >
            <label>FILTRAR POR RESIDENTES</label>
            <div class="d-flex align-items-center justify-content-center">
              <div class="form-check m-1">
                <input
                  :disabled="loading"
                  class="form-check-input"
                  type="checkbox"
                  v-model="resident_active"
                  @change="getResidents"
                  id="resident_active"
                />
                <label class="form-check-label" for="resident_active">
                  ATIVOS
                </label>
              </div>
              <div class="form-check m-1">
                <input
                  :disabled="loading"
                  class="form-check-input"
                  type="checkbox"
                  v-model="resident_not_active"
                  @change="getResidents"
                  id="resident_not_active"
                />
                <label class="form-check-label" for="resident_not_active">
                  INATIVOS
                </label>
              </div>
            </div>
          </div>
          <div
            class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
            v-show="!select_all_residents"
          >
            <h6>FILTRAR POR RESIDENTE:</h6>
            <select v-model="resident_id" class="form-control">
              <option value="">SELECIONE...</option>
              <option
                v-for="resident in residents"
                :key="resident.id"
                :value="resident.id"
              >
                {{ String(resident.name).toUpperCase() }} -
                {{ String(resident.status_type_name).toUpperCase() }}
              </option>
            </select>
          </div>
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <h6>FILTRAR POR QUAIS SITUAÇÕES?</h6>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                id="was_borrowed"
                v-model="was_borrowed"
              />
              <label class="form-check-label text-fifteen" for="was_borrowed">
                MEDICAMENTOS QUE O(S) RESIDENTE(S) PEGOU EMPRESTADO.
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                id="borrowed"
                v-model="borrowed"
              />
              <label class="form-check-label text-fifteen" for="borrowed">
                MEDICAMENTOS QUE O(S) RESIDENTE(S) EMPRESTOU.
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                id="received_return"
                v-model="received_return"
              />
              <label
                class="form-check-label text-fifteen"
                for="received_return"
              >
                MEDICAMENTOS QUE O(S) RESIDENTE(S) RECEBEU DEVOLUÇÃO.
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                id="made_return"
                v-model="made_return"
              />
              <label class="form-check-label text-fifteen" for="made_return">
                MEDICAMENTOS QUE O(S) RESIDENTE(S) FEZ DEVOLUÇÃO.
              </label>
            </div>
          </div>
          <div class="col-xl-12 col-sm-12 col-md-12 col-sm-12 col-12 pt-0 pb-0">
            <ErrorsMessages :errors="errors" />
          </div>
          <div
            class="col-xl-12 col-sm-12 col-md-12 col-sm-12 col-12 text-right"
          >
            <v-btn
              :disabled="loading"
              @click="paginate()"
              class="btn-filter"
              type="relief"
              ><i class="fas fa-filter mr-2 text-twenty"></i>

              {{ loading ? "CARREGANDO" : "FILTRAR" }}
            </v-btn>
          </div>
        </div>
      </b-modal>
      <div class="row filters">
        <div class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12 pt-0">
          <v-btn class="btn-return" v-on:click="handleToBack">
            <i class="fas fa-arrow-left mr-1"></i> Voltar
          </v-btn>
        </div>
        <div class="col-xl-7 col-lg-6 col-md-6 col-sm-9 col-12 pt-0">
          <h1 class="title-pages pt-1 check-text-center">
            RELATÓRIO: ESTOQUE EMPRESTADO NA CHECAGEM DOS MEDICAMENTOS
          </h1>
        </div>
        <div
          class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 pt-0 text-right"
        >
          <v-btn
            @click="$bvModal.show('filter')"
            class="btn-filter mr-2"
            type="relief"
          >
            <i class="fas fa-filter mr-2 text-twenty"></i> FILTRAR
          </v-btn>
          <v-btn
            :disabled="items.length == 0"
            @click="print"
            class="btn-print"
            type="relief"
          >
            <i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR
          </v-btn>
        </div>
        <div
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 v-clean p-5 text-center"
          v-if="items.length == 0"
        >
          <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
        </div>
        <div
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0"
          v-if="items.length > 0"
        >
          <h6 class="mb-0 upper-text worksansr check-text-center">
            FILTRANDO:
            <span v-if="select_all_residents"
              ><strong>TODOS OS RESIDENTES</strong> |
            </span>
            <span v-if="!select_all_residents"
              ><strong>{{ items[0].name }}</strong> |
            </span>
            <span v-if="was_borrowed">
              <strong>PEGOU EMPRESTADO</strong> |
            </span>
            <span v-if="borrowed"> <strong>EMPRESTOU</strong> | </span>
            <span v-if="received_return">
              <strong>RECEBEU DEVOLUÇÃO</strong> |
            </span>
            <span v-if="made_return"> <strong>FEZ DEVOLUÇÃO</strong> | </span>
          </h6>
        </div>
      </div>
      <b-overlay :show="loading" opacity="0.99">
        <table v-for="(resident, key) in items" :key="key" class="bg-white">
          <div class="row">
            <div
              class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12 check-text-center text-center"
            >
              <img
                v-if="rest_home_logo_url"
                class="rest_home_logo_url"
                :src="rest_home_logo_url"
              />
              <div v-if="!rest_home_logo_url" class="ml-1">
                <strong class="text-uppercase">{{ rest_home_name }}</strong>
              </div>
            </div>
            <div
              class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-12 d-flex align-items-center"
            >
              <img
                v-if="resident.photo_url"
                class="resident_photo_url"
                :src="resident.photo_url"
              />
              <img
                v-if="!resident.photo_url"
                class="resident_photo_url"
                :src="require('../../../assets/user.png')"
              />
              <div class="ml-3">
                <h6 class="m-0">
                  {{ resident.name }}
                </h6>
                <h6 class="legends mb-1 worksansr">
                  Data de nascimento:
                  {{ formatDate(resident.date_of_birth, false) }}
                  -
                  {{ getAge(resident.date_of_birth) }}
                  anos
                </h6>
                <h6 class="legends mb-1 worksansr">
                  Data de admissão:
                  {{ formatDate(resident.date_of_reception, false) }}
                </h6>
                <h6 class="legends mb-1 worksansr" v-if="resident.bed_id">
                  Leito Nº: {{ resident.bed_number }}, Andar:
                  {{ resident.bed_walk }}, ALA/Setor:
                  {{ resident.bed_ward_or_sector }}, Quarto:
                  {{ resident.bed_bedroom }}
                </h6>
                <h6 class="legends mb-1 worksansr">
                  Cadastrado:
                  {{ formatDate(resident.created_at, false) }}
                </h6>
              </div>
            </div>
            <div
              class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12 check-text-right"
            >
              <img class="logo" :src="logo" />
            </div>
          </div>

          <tbody>
            <tr>
              <td>
                <div class="content">
                  <div class="content-was-borrowed" v-if="was_borrowed">
                    <!-- MEDICAMENTOS QUE O(S) RESIDENTE(S) PEGOU EMPRESTADO -->
                    <WasBorrowed
                      :resident_id="resident.id"
                      :items="resident.was_borrowed"
                    />
                  </div>
                  <div class="content-borrowed" v-if="borrowed">
                    <!-- MEDICAMENTOS QUE O(S) RESIDENTE(S) EMPRESTOU -->
                    <Borrowed
                      :resident_id="resident.id"
                      :items="resident.borrowed"
                    />
                  </div>
                  <div class="content-received-return" v-if="received_return">
                    <!-- MEDICAMENTOS QUE O(S) RESIDENTE(S) RECEBEU DEVOLUÇÃO -->
                    <ReceivedReturn
                      :resident_id="resident.id"
                      :items="resident.received_return"
                    />
                  </div>
                  <div class="content-made-return" v-if="made_return">
                    <!-- MEDICAMENTOS QUE O(S) RESIDENTE(S) FEZ DEVOLUÇÃO -->
                    <MadeReturn
                      :resident_id="resident.id"
                      :items="resident.made_return"
                    />
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <errors-messages :errors="errors" />
      </b-overlay>
    </div>
  </div>
</template>

<script>
import api from "../../../services/api";

import routes from "../../../routes";

import { formatDate } from "../../../lib/format";

import { getAge } from "../../../lib/getAgeByDate";

import AuthBySessionExpired from "../../Components/AuthBySessionExpired";

import ErrorsMessages from "../../Components/ErrorsMessages";

import WasBorrowed from "./Borrowed/WasBorrowed";

import Borrowed from "./Borrowed/Borrowed";

import ReceivedReturn from "./Borrowed/ReceivedReturn";

import MadeReturn from "./Borrowed/MadeReturn";

import NavBar from "../../NavBar";

import { userData } from "../../../lib/functions";

export default {
  name: "ReportsStock",
  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
    WasBorrowed,
    Borrowed,
    ReceivedReturn,
    MadeReturn,
  },
  data() {
    return {
      resident_active: true,
      resident_not_active: false,
      items: [],
      residents: [],
      resident_id: "",
      filter: "SEM_ESTOQUE",
      rest_home_name: "",
      rest_home_fantasy_name: "",
      rest_home_logo_url: null,
      logo: null,
      loading: false,
      was_borrowed: false,
      borrowed: false,
      received_return: false,
      made_return: false,
      select_all_residents: false,
      errors: [],
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    getAge,
    formatDate,
    async retrieve() {
      const { user, logo } = userData();

      this.rest_home_name = user.rest_home_name;
      this.rest_home_fantasy_name = user.rest_home_fantasy_name;
      this.rest_home_logo_url = user.logo_url;
      this.logo = logo;

      await this.getResidents();

      let { modal } = this.$router.currentRoute.query;

      if (modal) {
        this.$bvModal.show("filter");
      }
    },
    async getResidents() {
      try {
        let { resident_active, resident_not_active } = this;

        let status = "ATIVO";

        if (resident_active && resident_not_active) {
          status = "ALL";
        } else if (!resident_active && resident_not_active) {
          status = "INATIVO";
        } else if (!resident_active && !resident_not_active) {
          this.errors = [
            {
              id: this.errors.length,
              message: "Informe residentes ativos, inativos ou ambos",
            },
          ];
          this.residents = [];
          return;
        }

        let params = { status };

        const response = await api.get("/rest-home/resident/paginate", {
          params,
        });

        const { error, errors, residents } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.residents = residents;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async paginate() {
      try {
        this.loading = true;

        this.items = [];

        const {
          resident_id,
          borrowed,
          was_borrowed,
          received_return,
          made_return,
          select_all_residents,
        } = this;

        var params = {
          resident_id,
          borrowed,
          was_borrowed,
          received_return,
          made_return,
          select_all_residents,
        };

        const response = await api.get(
          "/rest-home/report/stock-borrowed/filter",
          {
            params,
          }
        );

        const { residents, error, errors } = response.data;

        if (error) {
          this.items = [];
          this.errors = errors;
        } else {
          this.items = residents;
          this.errors = [];
          this.$bvModal.hide("filter");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    print() {
      window.print();
      routes;
      // let route = this.$router.resolve({
      //   name: "report_stock",
      //   params: {},
      // });

      // window.open(route.href, "_blank");
    },
    handleToBack: () => routes.go(-1),
  },
};
</script>

<style>
.report-borrowed .logo {
  height: 50px;
  object-fit: contain;
}
.report-borrowed table {
  width: 100%;
}
.report-borrowed .rest_home_logo_url {
  height: 80px;
  width: 100%;
  object-fit: contain;
}
.report-borrowed .resident_photo_url {
  width: 80px;
  height: 80px;
  border-radius: 40px;
  object-fit: cover;
}
@media print {
  /* .report-borrowed .table {
    page-break-after: always !important;
  } */
  .report-borrowed .content-was-borrowed {
    page-break-after: always !important;
  }
  .report-borrowed .content-borrowed {
    page-break-after: always !important;
  }
  .report-borrowed .content-received-return {
    page-break-after: always !important;
  }
  .report-borrowed .content-made-return {
    page-break-after: always !important;
  }
  .report-borrowed .was-borrowed {
    page-break-inside: avoid !important;
  }
  .report-borrowed .borrowed {
    page-break-inside: avoid !important;
  }
  .report-borrowed .received-return {
    page-break-inside: avoid !important;
  }
  .report-borrowed .made-return {
    page-break-inside: avoid !important;
  }
  .report-borrowed .nav--bar {
    display: none;
  }
  .report-borrowed .auth--by--session--expired {
    display: none;
  }
  .report-borrowed .filters {
    display: none;
  }
  .report-borrowed button {
    display: none;
  }
}
</style>
